import { checkoutWithStripe, createPaymentMethod } from "./payment.api.js"
import Vue from "vue"

import { loadStripe } from "@stripe/stripe-js/pure"

const state = {
  stripe: null,
  paymentLoading: false,
  trialIneligibility: false,
  paymentError: null,
  paymentMethod: null,
}
const getters = {
  paymentLoading: state => state.paymentLoading,
  trialIneligibility: state => state.trialIneligibility,
  paymentError: state => state.paymentError,
}
const mutations = {
  setStripe: (state, stripe) => (state.stripe = stripe),
  setPaymentLoading: (state, loading) => (state.paymentLoading = loading),
  setPaymentError: (state, paymentError) => (state.paymentError = paymentError),
  setTrialIneligibility: (state, trialIneligibility) =>
    (state.trialIneligibility = trialIneligibility),
  setPaymentMethod: (state, method) => (state.paymentMethod = method),
}
const actions = {
  async getRecaptchaToken ({ commit }) {
    try {
      await Vue.prototype.$recaptchaLoaded()
      const token = await Vue.prototype.$recaptcha("submit")
      return token
    } catch (error) {
      console.error(error)
      commit("setPaymentError", error.message)
      commit("setPaymentLoading", false)
    }
  },
  async startCheckoutWithStripe (
    { state, commit, dispatch },
    { products, form, promoCode }
  ) {
    try {
      if (state.paymentLoading) return
      commit("setPaymentError", "")
      commit("setPaymentLoading", true)
      if (form) {
        const data = await dispatch("createStripePaymentMethod", form)
        if (data === "failure") return "failure"
      }
      const result = await dispatch("createPaymentForm", {
        products,
        promoCode,
      })
      return result
    } catch (error) {
      console.error(error)
      commit("setPaymentError", error.message)
      commit("setPaymentLoading", false)
      return "failure"
    }
  },
  async createStripePaymentMethod ({ commit, dispatch }, form) {
    try {
      const recaptchaToken = await dispatch("getRecaptchaToken")
      form.append("g_recaptcha_response", recaptchaToken)
      const data = await createPaymentMethod(form)
      if (data.status === "failure") {
        commit("setPaymentError", data.message)
        commit("setPaymentLoading", false)
        return "failure"
      } else {
        await commit("setPaymentMethod", data.payment_method)
        dispatch(
          "Tracking/fbQuery",
          { event: "AddPaymentInfo" },
          { root: true }
        )
      }
    } catch (error) {
      commit("setPaymentError", error.message)
      commit("setPaymentLoading", false)
    }
  },
  async createPaymentForm (
    { state, dispatch, commit },
    { products, promoCode }
  ) {
    try {
      const recaptchaToken = await dispatch("getRecaptchaToken")
      const form = {
        g_recaptcha_response: recaptchaToken,
        payment_method_id: state.paymentMethod.id,
        product_ids: products.map(product => product.id),
      }
      if (promoCode) {
        form.promo_code = promoCode
      }
      const result = await dispatch("checkoutWithStripe", { form })
      return result
    } catch (error) {
      console.error(error)
      commit("setPaymentError", error.message)
      commit("setPaymentLoading", false)
      return "failure"
    }
  },

  async checkoutWithStripe ({ commit, dispatch, state }, { form }) {
    try {
      const data = await checkoutWithStripe(form)
      switch (data.status) {
        case "requires_action":
          await dispatch("loadStripe")
          const { error } = await state.stripe.confirmCardPayment(
            state.paymentIntentResponse.payment_intent_client_secret
          )
          if (error) {
            commit("setPaymentError", error.message)
            await commit("setPaymentLoading", false)
          } else {
            if (data.outstanding_invoice_id) {
              form.outstanding_invoice_id = data.outstanding_invoice_id
            }
            dispatch("checkoutWithStripe", { form })
          }
          break
        case "requires_payment_source":
        case "failure":
          commit("setPaymentError", data.paymentIntentResponse.message)
          await commit("setPaymentLoading", false)
          break
        case "success":
          commit("setPaymentLoading", false)
          return "success"
        default:
          break
      }
    } catch (error) {
      console.error(error)
      commit("setPaymentError", error.message)
      commit("setPaymentLoading", false)
      return "failure"
    }
  },
  async loadStripe ({ commit, state }) {
    if (state.stripe) return
    try {
      commit("setStripe", await loadStripe(process.env.STRIPE_PUBLIC_KEY))
    } catch (error) {
      console.error(error)
      commit("setStripeError", error.message)
      await commit("setStripeSubmitting", false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/payment.modules.js